import React from "react";
import { Link, useLocation } from "react-router-dom";
import s from "../styles/notfound.module.scss";

const NotFound = () => {
  const location = useLocation();

  const isEnglishPage = location.pathname.startsWith("/en");
  return (
    <div className={s.notFound}>
      <div className={s.main}>
        {isEnglishPage ? (
          <>
            <h2>This page doesnt exist,</h2>
            <h3>
              go back to the <Link to={"/en/"}>homepage</Link>{" "}
            </h3>
          </>
        ) : (
          <>
            <h2>Deze pagina bestaat niet,</h2>
            <h3>
              ga terug naar de <Link to={"/"}>thuispagina</Link>{" "}
            </h3>
          </>
        )}
        <span className={s.error}>404</span>
      </div>
    </div>
  );
};

export default NotFound;
